import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './P2pDispute.css';

const P2pDispute: React.FC = () => {
  const navigate = useNavigate();
  const [selectedReason, setSelectedReason] = useState<string>('not-released');
  const [additionalInfo, setAdditionalInfo] = useState<string>('');
  const [showDialog, setShowDialog] = useState<boolean>(true);

  const handleBack = () => {
    navigate(-1);
  };

  const handleChat = () => {
    console.log('Open chat');
  };

  const handleClose = () => {
    setShowDialog(false);
    setTimeout(() => navigate(-1), 200);
  };

  const handleCopyOrderId = () => {
    navigator.clipboard.writeText('9226448442254659');
    console.log('Order ID copied');
  };

  const handleSubmit = () => {
    console.log('Submit dispute:', { selectedReason, additionalInfo });
  };

  const disputeReasons = [
    { id: 'not-released', label: "Seller hasn't released the coin yet" },
    { id: 'not-responsive', label: "Seller isn't responsive" },
    { id: 'wrong-account', label: 'Seller sent different account info' }
  ];

  return (
    <div className="p2p-dispute-container">
      <header className="p2p-dispute-header">
        <button className="p2p-dispute-back-button" onClick={handleBack} aria-label="Go back">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        
        <h1 className="p2p-dispute-title">Buy USDT</h1>
        
        <button className="p2p-dispute-chat-button" onClick={handleChat} aria-label="Chat">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M17.5 8.33333C17.5 11.555 14.7 14.1667 11.25 14.1667C10.3375 14.1667 9.4675 13.98 8.675 13.6383L5 15L6.1175 11.3258C5.77583 10.5333 5.58917 9.66333 5.58917 8.75C5.58917 5.52833 8.38917 2.91667 11.8392 2.91667C15.2892 2.91667 18.0892 5.52833 18.0892 8.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </header>

      <div className="p2p-dispute-progress-bar">
        <div className="p2p-dispute-progress-fill" />
      </div>

      {showDialog && <div className="p2p-dispute-overlay" />}

      {showDialog && (
        <div className="p2p-dispute-dialog">
          <div className="p2p-dispute-dialog-header">
            <div className="p2p-dispute-dialog-header-content">
              <div className="p2p-dispute-icon-wrapper">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M10 6V10M10 14H10.01M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="p2p-dispute-dialog-header-text">
                <h2 className="p2p-dispute-dialog-heading">Dispute Order</h2>
                <p className="p2p-dispute-dialog-subheading">Report an issue with this trade</p>
              </div>
            </div>
            <button className="p2p-dispute-close-button" onClick={handleClose} aria-label="Close">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>

          <div className="p2p-dispute-dialog-content">
            <div className="p2p-dispute-info-card">
              <h3 className="p2p-dispute-section-label">Order Information</h3>
              
              <div className="p2p-dispute-info-row">
                <span className="p2p-dispute-info-key">Seller's Name</span>
                <div className="p2p-dispute-seller-badge">Emmyfon</div>
              </div>

              <div className="p2p-dispute-divider" />

              <div className="p2p-dispute-order-id-section">
                <span className="p2p-dispute-info-key">Order ID</span>
                <div className="p2p-dispute-order-id-box">
                  <span className="p2p-dispute-order-id-text">9226448442254659</span>
                  <button className="p2p-dispute-copy-button" onClick={handleCopyOrderId} aria-label="Copy Order ID">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <rect x="5.5" y="5.5" width="8" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
                      <path d="M3.5 10.5H2.5C1.94772 10.5 1.5 10.0523 1.5 9.5V2.5C1.5 1.94772 1.94772 1.5 2.5 1.5H9.5C10.0523 1.5 10.5 1.94772 10.5 2.5V3.5" stroke="currentColor" strokeWidth="1.5"/>
                    </svg>
                  </button>
                </div>
              </div>

              <div className="p2p-dispute-divider" />

              <div className="p2p-dispute-info-row">
                <span className="p2p-dispute-info-key">Time</span>
                <span className="p2p-dispute-info-value">Today at 1:41 PM</span>
              </div>
            </div>

            <div className="p2p-dispute-section">
              <div className="p2p-dispute-section-header">
                <div className="p2p-dispute-section-indicator" />
                <h3 className="p2p-dispute-section-title">Reason for dispute</h3>
              </div>

              <div className="p2p-dispute-radio-group">
                {disputeReasons.map((reason) => (
                  <label key={reason.id} className="p2p-dispute-radio-option">
                    <input
                      type="radio"
                      name="dispute-reason"
                      value={reason.id}
                      checked={selectedReason === reason.id}
                      onChange={(e) => setSelectedReason(e.target.value)}
                      className="p2p-dispute-radio-input"
                    />
                    <div className="p2p-dispute-radio-custom" />
                    <span className="p2p-dispute-radio-label">{reason.label}</span>
                  </label>
                ))}
              </div>
            </div>

            <div className="p2p-dispute-section">
              <div className="p2p-dispute-section-header">
                <div className="p2p-dispute-section-indicator orange" />
                <h3 className="p2p-dispute-section-title">Additional Information</h3>
              </div>

              <div className="p2p-dispute-textarea-wrapper">
                <textarea
                  className="p2p-dispute-textarea"
                  placeholder="Provide any additional details or evidence..."
                  value={additionalInfo}
                  onChange={(e) => setAdditionalInfo(e.target.value)}
                  maxLength={500}
                  rows={5}
                />
                <div className="p2p-dispute-char-count">{additionalInfo.length}/500</div>
              </div>
            </div>

            <button className="p2p-dispute-submit-button" onClick={handleSubmit}>
              Submit Dispute
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default P2pDispute;